export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";